export class User {
  groups: any[];
  id: number;
  permissions: any;
  resource_uri: string;
  username: string;
  added_this_session: boolean; // указывает, что пользователь добавлен во время текущего сеанса редактирования и еще не сохранен в базу
}
